class Utils {
  static settings = {
    hideClass: "hide",
    defaultBgColor: "#000"
  };
  constructor() {
    if (Utils.instance) return Utils.instance;
    Utils.instance = this, this.init()
  }
  init() {
    this.initDataTriggerHandler(), this.initSmoothScroll(), this.initTooltips(), this.initHeightEqualizer(), this.initFeatureScripts(), this.extendEventTargetPrototype()
  }
  initFeatureScripts() {
    this.initStickyButtonHandler()
  }
  initDataTriggerHandler() {
    document.body.addEventListener("click", (t => {
      const e = t.target.closest("[data-trigger]");
      if (e) {
        const t = e.getAttribute("data-trigger"),
          i = document.querySelector(t);
        i && i.click()
      }
    }))
  }
  initSmoothScroll() {
    document.body.addEventListener("click", (t => {
      const e = t.target.closest("[data-scroll]");
      if (e && e.getAttribute("href")) {
        t.preventDefault();
        const i = document.querySelector(e.getAttribute("href"));
        i && i.scrollIntoView({
          behavior: "smooth"
        })
      }
    }))
  }
  initTooltips() {
    document.body.addEventListener("mouseover", (t => {
      const e = t.target.closest("[data-snippet='tooltip']");
      e && e.setAttribute("data-active", "true")
    })), document.body.addEventListener("mouseout", (t => {
      const e = t.target.closest("[data-snippet='tooltip']");
      e && e.removeAttribute("data-active")
    }))
  }
  initHeightEqualizer() {
    this.applyHeightEqualization(), setTimeout((() => this.applyHeightEqualization()), 1500), window.addEventListener("resize", (() => this.applyHeightEqualization()))
  }
  applyHeightEqualization() {
    document.querySelectorAll("section").forEach((t => {
      this.equalizeHeight(t), this.setHeightVariable(t)
    }))
  }
  equalizeHeight(t) {
    const e = t.querySelectorAll('[data-height="equal"]');
    if (e.length > 0) {
      let i = 0;
      e.forEach((t => {
        t.style.height = "auto", i = Math.max(i, t.offsetHeight)
      })), i > 20 && t.style.setProperty("--element-heights", `${i}px`)
    }
  }
  setHeightVariable(t) {
    const e = t.querySelector('[data-height="set"]');
    if (e) {
      const i = e.offsetHeight;
      i > 20 && t.style.setProperty("--element-height", `${i}px`)
    }
  }
  extendEventTargetPrototype() {
    EventTarget.prototype.delegateListener || (EventTarget.prototype.delegateListener = function (t, e, i) {
      this.addEventListener(t, (t => {
        let s;
        Array.from(this.querySelectorAll(e)).reverse().filter((e => e.contains(t.target))).forEach((e => {
          void 0 !== s && !1 === s || (s = i.call(e, t))
        }))
      }))
    })
  }
  initStickyButtonHandler() {
    const t = document.querySelector(".sticky--button .button--primary");
    t && t.addEventListener("click", (() => {
      const t = document.querySelector('[type="submit"].product-form__submit');
      t && t.scrollIntoView({
        behavior: "smooth",
        block: "center"
      })
    }))
  }
}
document.addEventListener("DOMContentLoaded", (() => {
  new Utils
}));
class DropdownElement extends HTMLElement {
  connectedCallback() {
    this.init()
  }
  init() {
    Element.prototype.on = function (t, e, i = !1) {
      return this._eventNamespaces || (this._eventNamespaces = {}), this._eventNamespaces[t] = e, this.addEventListener(t.split(".")[0], e, i), this
    }, Element.prototype.off = function (t) {
      if (!this._eventNamespaces) return;
      const e = this._eventNamespaces[t];
      return e && (this.removeEventListener(t.split(".")[0], e), delete this._eventNamespaces[t]), this
    }, this.initializeDropdown()
  }
  initializeDropdown() {
    const t = {
        trigger: '[data-dropwdown="trigger"]',
        body: '[data-dropwdown="body"]',
        inner: ".dropdown--inner"
      },
      e = {
        open: "is-open",
        transitioning: "is-transitioning"
      };
    this.querySelectorAll(t.trigger).forEach((i => {
      const s = i.classList.contains(e.open);
      i.setAttribute("aria-expanded", s), i.off("click.dropdown"), i.on("click.dropdown", (i => this.toggleDropdown(i, t, e, false)))
    }))
  }
  toggleDropdown(t, e, i, s) {
    if (s) return;
    s = !0;
    const n = t.currentTarget,
      r = n.classList.contains(i.open),
      o = n.getAttribute("aria-controls"),
      l = this.querySelector(`#${o}`);
    if (!l) return void(s = !1);
    const a = l.querySelector(e.inner).offsetHeight;
    r ? (l.style.height = `${a}px`, requestAnimationFrame((() => {
      l.style.height = "0"
    }))) : (l.style.height = "0", requestAnimationFrame((() => {
      l.style.height = `${a}px`
    }))), l.addEventListener("transitionend", (() => {
      l.style.height = r ? "0" : "auto", l.classList.toggle(i.open, !r), s = !1
    }), {
      once: !0
    }), n.setAttribute("aria-expanded", !r), n.classList.toggle(i.open, !r)
  }
}
customElements.define("dropdown-element", DropdownElement);
class SliderElement extends HTMLElement {
  connectedCallback() {
    const t = this.getAttribute("data-settings"),
      e = t ? JSON.parse(t) : {},
      i = [],
      s = [],
      n = this.querySelector(".swiper"),
      r = this.closest("section"),
      o = r ? r.querySelector(".swiper-pagination") : null,
      l = r ? r.querySelector(".swiper-scrollbar") : null,
      a = r ? r.querySelector(".swiper-button-next") : null,
      c = r ? r.querySelector(".swiper-button-prev") : null;
    a && c && (i.push(a), s.push(c));
    const d = {
      loop: !0,
      spaceBetween: 10,
      autoplay: {
        delay: 8e3
      },
      navigation: {
        nextEl: i,
        prevEl: s
      }
    };
    o && (d.pagination = {
      el: o,
      clickable: !0
    }), e.thumbs && (e.thumbs.swiper = r.querySelector(".slider-thumbs .swiper")), l && (d.scrollbar = {
      el: l
    });
    const u = {
      ...d,
      ...e
    };
    new Swiper(n, u), this.removeAttribute("data-settings")
  }
}
customElements.define("slider-element", SliderElement);
class UpsellElement extends HTMLElement {
  constructor() {
    super(), this.upsellProductId = null, this.upsellProductIds = []
  }
  connectedCallback() {
    this.updateSelectedUpsell(), this.addEventListeners(), this.checkAndFixCart()
  }
  addEventListeners() {
    this.querySelectorAll("input[type='radio']").forEach((t => {
      t.addEventListener("change", (() => this.handleSelectionChange()))
    })), document.addEventListener("upsell:update", (t => {
      this.checkAndFixCart(t.detail)
    }))
  }
  updateSelectedUpsell() {
    let t = this.querySelector("input[type='radio']:checked");
    this.upsellProductId = t ? t.value : null, this.upsellProductIds = Array.from(this.querySelectorAll("input[type='radio']")).map((t => t.value))
  }
  async fetchCart() {
    try {
      let t = await fetch("/cart.js");
      return await t.json()
    } catch (t) {
      return console.error("UpsellElement: Error fetching cart:", t), null
    }
  }
  async checkAndFixCart(t = null) {
    let e = t || await this.fetchCart();
    if (!e) return;
    let i = e.items.filter((t => this.upsellProductIds.includes(String(t.id)))).map((t => String(t.id))),
      s = e.items.some((t => !this.upsellProductIds.includes(String(t.id)))),
      n = {};
    i.length > 1 && i.forEach((t => {
      t !== this.upsellProductId && (n[t] = 0)
    })), s && !i.includes(this.upsellProductId) && this.upsellProductId && (n[this.upsellProductId] = 1), !s && i.length > 0 && i.forEach((t => n[t] = 0)), Object.keys(n).length > 0 && this.modifyCart({
      updates: n,
      sections: this.getSectionSelectors()
    })
  }
  handleSelectionChange() {
    let t = this.upsellProductId;
    this.updateSelectedUpsell();
    let e = {};
    t && t !== this.upsellProductId && (e[t] = 0), this.upsellProductId && (e[this.upsellProductId] = 1), Object.keys(e).length > 0 && this.modifyCart({
      updates: e,
      sections: this.getSectionSelectors()
    })
  }
  modifyCart(t) {
    document.querySelector(".cart-main")?.classList.add("style--sectionLoading"), fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(t)
    }).then((t => t.json())).then((t => {
      publish("cartPage-update", {
        source: "cart-items",
        cartData: t,
        variantId: this.upsellProductId
      })
    })).catch((t => console.error("UpsellElement: Error updating cart:", t)))
  }
  getSectionSelectors() {
    return [document.getElementById("main-cart-footer")?.dataset.id, "cart-icon-bubble", "cart-live-region-text", document.getElementById("main-cart-items")?.dataset.id].filter(Boolean)
  }
}
customElements.define("upsell-element", UpsellElement);
